import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import SpaceForm from '../Form';
import { createSpace } from '@resources/Space/actions';
import { useIntl } from 'react-intl';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';

const Create = (props) => {
	const { createSpace, visible, onCancel, module } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createSpace(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.space.create',
						defaultMessage:
							'A new Space has been successfully created',
					})
				);
				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.space',
					defaultMessage: 'Create Space',
				})}
			</Title>
			<SpaceForm {...props} onSubmit={handleSubmit} module={module} />
		</Modal>
	);
};

const mapStateToProps = ({
	spaces,
	modules,
	event,
	facility,
	ministry,
	cellGroup,
	organization,
}) => {
	return {
		spaces,
		ministry,
		facility,
		modules,
		event,
		cellGroup,
		organization,
	};
};

export default connect(mapStateToProps, {
	createSpace,
	fetchModulesBySubmoduleCode,
})(Create);
